module.exports = __webpack_public_path__ + "img/epk-popust-oct-2026.b1598688.webp";